<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <tabs v-model="activeTab" @input="changeTab" class="empty-tab">
        <tab
          :key="`tab-${index}`"
          v-for="(tab, index) of authorizedTabs"
          :header="tab.label"
        >
        </tab>
      </tabs>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  components: {
    Tabs,
    Tab,
  },

  data() {
    return {
      activeTab: 0,
      tabs: [
        {
          label: "Marketing",
          name: "marketing",
          children: ["expense", "ca-roas", "form-expense"],
          requiredPermission: "STATS_MARKETING_READ",
        },
        {
          label: "Pertes",
          name: "lost",
          children: ["lost-prospects-clients", "lost-sources", "lost-map"],
          requiredPermission: "STATS_LOST_READ",
        },
        {
          label: "Commerciaux",
          name: "commercials",
          children: [
            "statistique-commercials",
            "acquisition",
            "cashed-payments",
            "attributions-stats",
            "margin-rate",
            "b2c2b",
          ],
          requiredPermission: "STATS_COMMERCIALS_READ",
        },
      ],
    };
  },

  computed: {
    authorizedTabs() {
      return this.tabs.filter((tab) => {
        return this.hasPermission(
          this.$store.state.user,
          tab.requiredPermission,
        );
      });
    },
  },

  created() {
    this.setCurrentTab(this.$route.name);
  },

  methods: {
    changeTab(index) {
      if (index >= 0) {
        this.$router.push({ name: this.authorizedTabs[index].name });
      }
    },

    setCurrentTab(currentPath) {
      this.activeTab = this.authorizedTabs.findIndex(
        (tab) =>
          tab.name === currentPath || tab.children?.includes(currentPath),
      );
    },
  },

  watch: {
    $route(current) {
      this.setCurrentTab(current.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-tab {
  .nav.nav-tabs {
    margin-bottom: 15px;
  }

  & > .tab-content {
    display: none;
  }
}
</style>
